import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box, Typography } from '@material-ui/core';
import MiniToggleSwitch from '../../../../components/ToggleSwitchSmall/ToggleSwitchSmall';
import FilterButton from '../../../../components/FilterModal/FilterButton';
import FilterProductVariantsModal from '../../../../components/FilterModal/FilterProductVariantsModal';
import FilterCombosModal from '../../../../components/FilterModal/FilterCombosModal';
import { useContext } from 'react';
import { CustomizationContext } from '../../../../utils/ClientCustomizationsProvider';
import { useCallback } from 'react';
import { useMemo } from 'react';
const NoteHead = styled.div`
  font-size: 17px;
  color: #191818;
  font-weight: 600;
  margin-bottom: 5px;
`;

const FlexBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => {
    const match = part.match(/(\w+)\[(\d+)\]/);
    if (match) {
      const key = match[1];
      const index = parseInt(match[2], 10);
      return acc?.[key]?.[index];
    }
    return acc?.[part];
  }, obj);
};
function SelectProductVariantsAndCombos({
  setFieldValue,
  values = {},
  applyToAllToggle = true,
  selectProducts = true,
  selectCombos = true,
  allProducts = [],
  allCombos = [],
  isEmptyEqualAll = true,
  isBlankAcceptable = true,
  isSelectAllAvailable = true,
  isEmptyAccepted = false,
  combosList = [],
  indexItem,
  productIndex,
  isFromRequirement,
  selectedOfferTypes,
  currentSource,
}) {
  const formFieldKey = isFromRequirement ? 'requirements' : 'reward';
  const isAllCombosSelected =
    isEmptyEqualAll &&
    values?.conditionValue[indexItem][formFieldKey]?.combos?.length === 0;

  const isFreeProductOffer =
    values?.offer_details?.template_name === 'free-item';
  let baseKey = 'conditionValue';
  let productsKey = 'product.products';
  let combosKey = 'combo.combos';

  if (typeof indexItem !== 'undefined') {
    baseKey = `conditionValue[${indexItem}]`;

    if (typeof productIndex !== 'undefined') {
      baseKey += `.requirements[${productIndex}]`;
      productsKey = `${baseKey}.product.products`;
      combosKey = `${baseKey}.combo.combos`;
    } else {
      baseKey += `.reward`;
      productsKey = `${baseKey}.products`;
      combosKey = `${baseKey}.combos`;
    }
  }
  const productsExist = Array.isArray(allProducts) && allProducts.length > 0;
  const combosExist = Array.isArray(allCombos) && allCombos.length > 0;

  const [isProductsFilterOpen, setIsProductsFilterOpen] = useState(false);
  const [isCombosFilterOpen, setIsCombosFilterOpen] = useState(false);
  const [isAllProductsSelected, setIsAllProductsSelected] = useState(false);
  const [isProductToggleChecked, setIsProductToggleChecked] = useState(false);
  const [isCombosToggleChecked, setIsCombosToggleChecked] = useState(false);
  const templateName = values.offer_details?.template_name || '';

  const handleSave = (inType, data) => {
    console.log('data', data);
    const key = inType === 'combos' ? combosKey : productsKey;
    if (isFromRequirement && data === null) {
      // Remove the whole element if it has the property for inType
      const type = inType === 'combos' ? 'combo' : 'product';
      const newRequirements = values.conditionValue[
        indexItem
      ].requirements.filter(
        (item) => !item[type] // keep only items that do NOT have the property
      );

      console.log('newRequirements', newRequirements);
      setFieldValue(
        `conditionValue[${indexItem}].requirements`,
        newRequirements
      );
      return;
    }

    setFieldValue(key, data);
  };
  useEffect(() => {
    if (!isEmptyEqualAll) {
      if (getNestedValue(values, productsKey)?.length === 0) {
        handleSave('products', []);
      }
      if (getNestedValue(values, combosKey)?.length === 0) {
        handleSave('combos', []);
      }
    }
  }, [templateName]);

  const stateProduct = getNestedValue(values, `${productsKey}`);
  useEffect(() => {
    let count = 0;
    allProducts?.forEach((product) => {
      if (product.prices?.length > 0) {
        product.prices.forEach((variant) => count++);
      } else {
        count++;
      }
    });
    const mappedProductVariants = getNestedValue(values, `${baseKey}`)
      ? getNestedValue(values, `${productsKey}`)
      : [];
    if (
      count === mappedProductVariants?.length ||
      mappedProductVariants?.length === 0
    ) {
      setIsAllProductsSelected(true);
    } else {
      setIsAllProductsSelected(false);
    }
  }, [stateProduct, allProducts]);

  const handleUpdateCombos = (combos) => {
    setFieldValue(combosKey, combos);
  };

  const handleUpdateProducts = (products) => {
    if (!isEmptyEqualAll && !isBlankAcceptable && products.length === 0) {
      return;
    } else {
      setFieldValue(productsKey, products);
    }
  };
  const getFilteredProducts = () => {
    const productsField = getNestedValue(values, productsKey);

    // If there are selected products already in the form
    if (productsField && productsField.length > 0) {
      return productsField;
    }

    // If the "empty equal all" condition is met, format the selected product variants
    if (isEmptyEqualAll) {
      let formattedSelectedProductVariants = [];
      allProducts.forEach((product) => {
        let newProductVariant;
        if (product.variants?.length > 0) {
          product.variants.forEach((variant) => {
            newProductVariant = {
              product_id: product.id,
              variant_id: variant.id,
            };
            formattedSelectedProductVariants.push(newProductVariant);
          });
        } else {
          newProductVariant = { product_id: product.id };
          formattedSelectedProductVariants.push(newProductVariant);
        }
      });
      return formattedSelectedProductVariants;
    }

    return [];
  };

  <FilterProductVariantsModal
    type='product'
    placeholder='Enter Product/Variants Name'
    searchLabel='Search by Product/Variants Name'
    filteredProducts={getFilteredProducts()}
    setFilteredProducts={handleUpdateProducts}
    isAllProductsSelected={isAllProductsSelected}
    isOpen={isProductsFilterOpen}
    setIsOpen={setIsProductsFilterOpen}
    formField={productsKey}
    setFieldValue={setFieldValue}
    emptyIsEqualToAll={values.offer_details.template_name !== 'free-item'}
    isEmptyAccepted={values.offer_details.template_name !== 'free-item'}
    handleSave={(data) => handleSave('products', data)}
  />;

  if (!productsExist && !combosExist) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <NoteHead>No Products and No Combos available to select</NoteHead>
      </Box>
    );
  }

  const errorMessage = useMemo(() => {
    if (!isFromRequirement) {
      if (
        values?.conditionValue[indexItem][formFieldKey]?.combos === null &&
        values?.conditionValue[indexItem][formFieldKey]?.products === null
      ) {
        return 'At least one product or combo must be selected.';
      }
      if (
        selectedOfferTypes?.[currentSource]?.includes('products') &&
        values?.conditionValue[indexItem][formFieldKey]?.products === null
      ) {
        return 'At least one product must be selected.';
      }
      if (
        selectedOfferTypes?.[currentSource]?.includes('combos') &&
        values?.conditionValue[indexItem][formFieldKey]?.combos === null
      ) {
        return 'At least one combo must be selected';
      }
    }
    return null;
  }, [
    values,
    productsKey,
    combosKey,
    selectedOfferTypes,
    indexItem,
    formFieldKey,
    isFromRequirement,
  ]);

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {/* {productsExist &&
          applyToAllToggle &&
          !isFromRequirement &&
          !isFreeProductOffer && (
            <ApplyDiscountToAllToggle
              toggleType='products'
              productsKey={productsKey}
              combosKey={combosKey}
              setFieldValue={setFieldValue}
              setIsProductToggleChecked={setIsProductToggleChecked}
              isProductToggleChecked={isProductToggleChecked}
              setIsCombosToggleChecked={setIsCombosToggleChecked}
              isCombosToggleChecked={isCombosToggleChecked}
              combosList={combosList}
              allProducts={allProducts}
              templateName={templateName}
              isEmptyEqualAll={isEmptyEqualAll}
            />
          )} */}
        {/* {selectProducts && productsExist && ( */}
        {(selectedOfferTypes?.[currentSource]?.includes('products') ||
          isFromRequirement) && (
          <AddComboProductFilterBtn
            type='products'
            values={values}
            formFieldKey={productsKey}
            setIsOpen={setIsProductsFilterOpen}
            setFieldValue={setFieldValue}
            isToggleChecked={isProductToggleChecked}
            isEmptyEqualAll={isEmptyEqualAll && !isFromRequirement}
            isBlankAcceptable={isBlankAcceptable}
          />
        )}

        {/* {combosExist &&
          applyToAllToggle &&
          !isFromRequirement &&
          !isFreeProductOffer && (
            <ApplyDiscountToAllToggle
              toggleType='combos'
              productsKey={productsKey}
              combosKey={combosKey}
              setFieldValue={setFieldValue}
              setIsProductToggleChecked={setIsProductToggleChecked}
              isProductToggleChecked={isProductToggleChecked}
              setIsCombosToggleChecked={setIsCombosToggleChecked}
              isCombosToggleChecked={isCombosToggleChecked}
              combosList={combosList}
              allProducts={allProducts}
              templateName={templateName}
              isEmptyEqualAll={isEmptyEqualAll}
            />
          )} */}
        {(selectedOfferTypes?.[currentSource]?.includes('combos') ||
          isFromRequirement) && (
          <AddComboProductFilterBtn
            type='combos'
            values={values}
            formFieldKey={combosKey}
            setIsOpen={setIsCombosFilterOpen}
            setFieldValue={setFieldValue}
            isToggleChecked={isCombosToggleChecked}
            isEmptyEqualAll={
              values.offer_details.template_name !== 'free-item' &&
              values.offer_details.template_name !== 'fixed-price' &&
              !isFromRequirement
            }
            isBlankAcceptable={isBlankAcceptable}
          />
        )}
      </Box>
      {errorMessage && <Box sx={{ color: 'red', mt: 1 }}>{errorMessage}</Box>}
      {isProductsFilterOpen && productsExist && (
        <FilterProductVariantsModal
          type='product'
          placeholder='Enter Product/Variants Name'
          searchLabel='Search by Product/Variants Name'
          filteredProducts={
            getNestedValue(values, productsKey)
              ? getNestedValue(values, productsKey).length > 0
                ? getNestedValue(values, productsKey)
                : isEmptyEqualAll
                ? getFilteredProducts()
                : []
              : []
          }
          setFilteredProducts={handleUpdateProducts}
          isAllProductsSelected={isAllProductsSelected}
          isOpen={isProductsFilterOpen}
          setIsOpen={setIsProductsFilterOpen}
          formField={productsKey}
          setFieldValue={!isFromRequirement ? setFieldValue : undefined}
          emptyIsEqualToAll={
            values.offer_details.template_name !== 'free-item' &&
            values.offer_details.template_name !== 'fixed-price' &&
            !isFromRequirement
          }
          isEmptyAccepted={true}
          handleSave={(data) => {
            handleSave('products', data);
          }}
        />
      )}
      {isCombosFilterOpen && combosExist && (
        <FilterCombosModal
          placeholder='Enter Combo Name'
          searchLabel='Search by Combo Name'
          filteredCombos={
            getNestedValue(values, combosKey)
              ? getNestedValue(values, combosKey).length > 0
                ? getNestedValue(values, combosKey)
                : isEmptyEqualAll
                ? combosList.map((combo) => ({ combo_id: combo.id }))
                : []
              : []
          }
          setFilteredCombos={handleUpdateCombos}
          isOpen={isCombosFilterOpen}
          setIsOpen={setIsCombosFilterOpen}
          isEmptyAccepted={true}
          formField={combosKey}
          setFieldValue={setFieldValue}
          emptyIsEqualToAll={
            values.offer_details.template_name !== 'free-item' &&
            values.offer_details.template_name !== 'fixed-price' &&
            !isFromRequirement
          }
          isSelectAllAvailable={isSelectAllAvailable}
          handleSave={(data) => {
            handleSave('combos', data);
          }}
        />
      )}
    </>
  );
}

function ApplyDiscountToAllToggle({
  setFieldValue,
  productsKey,
  combosKey,
  setIsProductToggleChecked,
  isProductToggleChecked,
  setIsCombosToggleChecked,
  isCombosToggleChecked,
  combosList,
  allProducts,
  isEmptyEqualAll = true,
  toggleType,
}) {
  const setAllProductItemsChecked = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      setIsProductToggleChecked(isChecked);
      if (isEmptyEqualAll || !isChecked) {
        setFieldValue(`${productsKey}`, []);
      } else {
        let formattedSelectedProductVariants = [];
        allProducts.forEach((product) => {
          let newProductVariant;
          if (product.variants?.length > 0) {
            product.variants.forEach((variant) => {
              newProductVariant = {
                product_id: product.id,
                variant_id: variant.id,
              };
              formattedSelectedProductVariants.push(newProductVariant);
            });
          } else {
            newProductVariant = { product_id: product.id };
            formattedSelectedProductVariants.push(newProductVariant);
          }
        });
        setFieldValue(`${productsKey}`, formattedSelectedProductVariants);
      }
    },
    [isEmptyEqualAll, setFieldValue, productsKey]
  );
  const setAllCombosItemsChecked = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      setIsCombosToggleChecked(isChecked);
      if (isEmptyEqualAll) {
        setFieldValue(`${combosKey}`, []);
      } else {
        const newCombosList = combosList.map((combo) => ({
          combo_id: combo.id,
        }));
        setFieldValue(`${combosKey}`, newCombosList);
      }
    },
    [isEmptyEqualAll, setFieldValue, combosKey]
  );

  return (
    <FlexBoxContainer>
      <Box>
        <MiniToggleSwitch
          label={`Apply discount to all the ${
            toggleType === 'products' ? 'Products' : 'Combos'
          }`}
          checked={
            toggleType === 'products'
              ? isProductToggleChecked
              : isCombosToggleChecked
          }
          onChange={(e) =>
            toggleType === 'products'
              ? setAllProductItemsChecked(e)
              : setAllCombosItemsChecked(e)
          }
        />
      </Box>
    </FlexBoxContainer>
  );
}

function AddComboProductFilterBtn({
  type,
  values,
  setIsOpen,
  formFieldKey,
  isToggleChecked,
  isEmptyEqualAll = true,
}) {
  const typeString = type === 'combos' ? 'Combo' : 'Product Variant';
  const title = `Select ${typeString}(s) that will be eligible for the offer`;
  const selectedCount = getNestedValue(values, `${formFieldKey}`)?.length ?? -1;

  const message =
    isEmptyEqualAll && selectedCount === 0
      ? `All ${typeString}s Selected`
      : isEmptyEqualAll && selectedCount === -1
      ? `Selected ${typeString}s (0)`
      : !isEmptyEqualAll && selectedCount === 0
      ? `Selected ${typeString}s (0)`
      : !isEmptyEqualAll && selectedCount === -1
      ? `Selected ${typeString}s (0)`
      : `Selected ${typeString}s (${selectedCount})`;
  return (
    <Box display='flex' flexDirection='column' alignItems='flex-start' mt={2}>
      <NoteHead>{title}</NoteHead>

      {isToggleChecked ? (
        <FilterButton
          message={`All ${typeString}s Selected`}
          height='55px'
          isDisabled={true}
        />
      ) : (
        <FilterButton
          message={message}
          height='55px'
          setIsOpen={setIsOpen}
          isDisabled={false}
        />
      )}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  allProducts: state.productsReducer.allProductVariants,

  allCombos: state.combosReducer.combosList,
  combosList: state.combosReducer.combosList,
});

export default connect(mapStateToProps)(SelectProductVariantsAndCombos);
